import { render } from "./TheRefund.vue?vue&type=template&id=2b4ac2d3&scoped=true"
import script from "./TheRefund.vue?vue&type=script&lang=js"
export * from "./TheRefund.vue?vue&type=script&lang=js"

import "./TheRefund.vue?vue&type=style&index=0&id=2b4ac2d3&scoped=true&lang=css"

import exportComponent from "D:\\code\\tea-web\\tea-web\\tea-vue\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b4ac2d3"]])

export default __exports__